import { ApplicationConfig, inject, provideAppInitializer, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors, withFetch } from '@angular/common/http';
import { registerLocaleData } from '@angular/common';
import { LOCALE_ID } from '@angular/core';
import localePt from '@angular/common/locales/pt';
import { Injectable } from '@angular/core';
import { provideNativeDateAdapter, MAT_DATE_LOCALE, DateAdapter, NativeDateAdapter } from '@angular/material/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';

@Injectable()
class MondayFirstDateAdapter extends NativeDateAdapter {
  override getFirstDayOfWeek(): number {
    return 1;
  }
}

import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { SsoService } from './core/services/sso.service';

// Register Portuguese locale
registerLocaleData(localePt);

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    // login-farmacias: consume a sign-in redirect and re-adopt a cached group session before routing.
    provideAppInitializer(() => inject(SsoService).init()),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor]), withFetch()),
    { provide: LOCALE_ID, useValue: 'pt-PT' }, // Set Portuguese locale as default
    provideNativeDateAdapter(),
    { provide: MAT_DATE_LOCALE, useValue: 'pt-PT' },
    { provide: DateAdapter, useClass: MondayFirstDateAdapter },
    // PrimeNG overlays (the Amily tab's period select and record dialog) use Angular animations.
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Aura,
        // EzfyWeb is light only: with the OS in dark mode, PrimeNG's dialogs and selects turned dark around light content.
        options: { darkModeSelector: false }
      }
    })
  ]
};
